/**
 * Redux Store Configuration
 *
 * Central store for the entire Beacon application.
 * All slice reducers are registered here.
 */
import { configureStore } from '@reduxjs/toolkit';
import envReducer from './slices/env/envSlice';
import notificationReducer from './slices/notifications/notificationSlice';
import paymentDetailReducer from './slices/paymentDetail/paymentDetailSlice';
import artifactDetailReducer from './slices/artifactDetail/artifactDetailSlice';
import executionDetailReducer from './slices/executionDetail/executionDetailSlice';
import searchPaymentsReducer from './slices/searchPayments/searchPaymentsSlice';
import searchArtifactsReducer from './slices/searchArtifacts/searchArtifactsSlice';
import searchExecutionsReducer from './slices/searchExecutions/searchExecutionsSlice';
import bulkSearchUiReducer from './slices/bulkSearchUi/bulkSearchUiSlice';
import paymentAnalyticsReducer from './slices/paymentAnalytics/paymentAnalyticsSlice';
import { listenerMiddleware } from './regionListener';

export const store = configureStore({
  reducer: {
    env: envReducer,
    notifications: notificationReducer,
    paymentDetail: paymentDetailReducer,
    artifactDetail: artifactDetailReducer,
    executionDetail: executionDetailReducer,
    searchPayments: searchPaymentsReducer,
    searchArtifacts: searchArtifactsReducer,
    searchExecutions: searchExecutionsReducer,
    bulkSearchUi: bulkSearchUiReducer,
    paymentAnalytics: paymentAnalyticsReducer,
  },
  // Region listener: re-runs the active query + syncs the URL on region change.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
